<template>
	<div class="box" v-loading="loading">
		<div class="box-content">
			<div class="box-content-item">
				<div class="box-content-item-user">
					<div class="nav">
						<button v-for="(item,index) in navList" :key="index" :class="index === navListIndex?'nav-item':'nav-item1'" @click="handleNav(index)">{{item.name}}</button>
					</div>
					<div class="user-list">
						<div class="box-content-item-user-item" v-for="(item,index) in userList" :key="index">
							<div class="box-content-item-user-item-left">
								<img class="box-content-item-user-item-left-img" :src="item.headPortrait" alt="" />
								<div class="box-content-item-user-item-left-content">
									<div class="box-content-item-user-item-left-content-name">
										<img src="../assets/images/guan.png" alt="" v-if="item.isAnchor == 1"/>
										<span>{{item.nickName}}</span>
									</div>
									<span class="box-content-item-user-item-left-content-span">ID:{{item.recodeCode}}</span>
								</div>
							</div>
							<div class="box-content-item-user-item-box">
								<button class="box-content-item-user-item-box-btn1" v-if="navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 0" @click="addForbid(item.userId,3)">禁止评论</button>
								<button class="box-content-item-user-item-box-btn" v-if="navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 1" @click="relieveForbid(item.userId,3)">允许评论</button>
								<button class="box-content-item-user-item-box-btn1" v-if="navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 0" @click="addForbid(item.userId,1)">禁止购买</button>
								<button class="box-content-item-user-item-box-btn" v-if="navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 1" @click="relieveForbid(item.userId,1)">允许购买</button>
								<button class="box-content-item-user-item-box-btn1" v-if="navListIndex == 0 && item.isAnchor != 1" @click="addForbid(item.userId,2)">禁止访问</button>
								<button class="box-content-item-user-item-box-btn" v-if="navListIndex == 1 && item.isAnchor != 1" @click="relieveForbid(item.userId,2)">允许访问</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="box-content-container">
				<div class="box-content-container-title">直播大屏</div>
				<div class="zhiboxiangqing" v-if="data">
					<img class="zhiboxiangqing-img" :src="data.coverUrl" alt="" />
					<span class="zhiboxiangqing-span">{{data.roomName}}</span>
					<div class="zhibozhong">
						<img src="../assets/images/renshu@2x.png" alt="" />
						<span>{{data.roomStatus === 1?'直播中':'已结束'}}</span>
					</div>
					<span class="zhiboxiangqing-span1">开播时间：{{data.beginTime}}</span>
				</div>
				<div class="box-data">
					<div class="chengjiao">
						<span class="chengjiao-span">直播间成交金额</span>
						<span class="chengjiao-span1">US{{liveInData.orderPaySumAmount?liveInData.orderPaySumAmount:0}}</span>
					</div>
					<div class="box-data-list">
						<div class="box-data-list-box">
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">实时在线</span>
								<span class="box-data-list-item-span1">{{liveInData.viewUserNum?liveInData.viewUserNum:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">观看人次</span>
								<span class="box-data-list-item-span1">{{liveInData.viewUserCount?liveInData.viewUserCount:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">新增用户</span>
								<span class="box-data-list-item-span1">{{liveInData.adduserNum?liveInData.adduserNum:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">峰值在线人数</span>
								<span class="box-data-list-item-span1">{{liveInData.onlineNum?liveInData.onlineNum:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">评论人数</span>
								<span class="box-data-list-item-span1">{{liveInData.commentNum?liveInData.commentNum:0}}</span>
							</div>
						</div>
						<div class="box-data-list-box">
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">点赞次数</span>
								<span class="box-data-list-item-span1">{{liveInData.giveCount?liveInData.giveCount:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">总订单数</span>
								<span class="box-data-list-item-span1">{{liveInData.orderCount?liveInData.orderCount:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">商品浏览次数</span>
								<span class="box-data-list-item-span1">{{liveInData.goodsViewCount?liveInData.goodsViewCount:0}}</span>
							</div>
							<div class="box-data-list-item">
								<span class="box-data-list-item-span">成交观众数</span>
								<span class="box-data-list-item-span1">{{liveInData.orderUserNum?liveInData.orderUserNum:0}}</span>
							</div>
							<div class="box-data-list-item">
								
							</div>
						</div>
					</div>
					
				</div>
				<div class="goods">
					<div class="goods-list">
						<div class="goods-list-item" v-for="(item,index) in goodsList" :key="index">
							<div class="goods-list-item-top">
								<div class="goods-list-item-top-img">
									<img class="goods-list-item-top-img-img" :src="item.masterImg[0]" alt="" />
									<div class="paixu">{{item.sort}}</div>
									<div class="jiangjiezhong" v-if="item.isExplain == 1">
										<img src="../assets/images/renshu@2x.png" alt="" />
										<span>讲解中</span>
									</div>
								</div>
								<div class="goods-list-item-top-content">
									<div class="goods-name">{{item.goodsName}}</div>
									<div class="goods-price">
										<span class="goods-price-span">US{{item.price}}</span>
									</div>
									<div class="goods-dingshi">
										<span v-if="item.taskListedTime">定时上架时间:{{item.taskListedTime}}</span>
									    <span v-if="item.taskShelvesTime">定时下架时间:{{item.taskShelvesTime}}</span>
									</div>
									<div class="goods-list-item-btn">
										<span class="goods-price-span1">库存：{{item.inventory}}</span>
										<div class="goods-list-item-btn-box">
											<button class="goods-list-item-btn-btn1" @click="handleUpdateKc(item)">库存</button>
											<button class="goods-list-item-btn-btn" @click="updateGoodsSort(item.dbRecordId,0)">上移</button>
											<button class="goods-list-item-btn-btn" @click="updateGoodsSort(item.dbRecordId,1)">下移</button>
											<button class="goods-list-item-btn-btn" v-if="item.goodsStatus==2 || item.goodsStatus==3" @click="updateGoodsStatus(item.dbRecordId,1)">上架</button>
											<button class="goods-list-item-btn-btn" v-if="item.goodsStatus==1" @click="updateGoodsStatus(item.dbRecordId,2)">下架</button>
											<button class="goods-list-item-btn-btn" v-if="item.goodsStatus==1 || item.goodsStatus==2" @click="updateGoodsStatus(item.dbRecordId,3)">售罄</button>
											<button class="goods-list-item-btn-btn2" @click="handleUpdateDssj(item)">定时上架</button>
											<button class="goods-list-item-btn-btn2" @click="handleUpdateDsxj(item)">定时下架</button>
											<button class="goods-list-item-btn-btn" @click="handleDelete(item)">移除</button>
											<button class="goods-list-item-btn-btn1" v-if="item.isExplain == 0" @click="updateGoodsExplanationStatus(item.dbRecordId,1)">讲解</button>
											<button class="goods-list-item-btn-btn1" v-if="item.isExplain == 1" @click="updateGoodsExplanationStatus(item.dbRecordId,0)">取消</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			<div class="box-content-video">
				<div class="video-container">
				    <!-- 新增：底层图片（宽高100%填充容器） -->
				    <img 
				      class="video-bg-img" 
				      :src="data.coverUrl"
				      alt="视频背景图" 
				    >
				    <!-- 远程视频渲染区域（会覆盖在图片上方） -->
				    <div id="remote-video" ref="remoteVideo" class="remote-video"></div>
				  </div>
				<div class="danmu" ref="danmuContainer">
					<div class="danmaku-body-item" v-for="(item,index) in msgList" :key="index">
						<el-dropdown @command="handleCommand"> <!-- 统一处理命令 -->
						  <div class="danmaku-body-item-box">
						    <!-- 弹幕内容部分保持不变 -->
						    <span class="guanliyuan" v-if="item.sendUserInfo && item.sendUserInfo.isAnchor == 1">管理员</span>
						    <span class="danmaku-body-item-box-text" v-if="item.sendUserInfo">{{item.sendUserInfo.nickName}}：</span>
						    <span class="danmaku-body-item-box-text1" v-if="item.sendUserInfo && item.type != 10">{{item.title}}</span>
						    <span class="danmaku-body-item-box-text2" v-if="!item.sendUserInfo && item.type != 10">{{item.title}}</span>
						    <span class="danmaku-body-item-box-text3" v-if="item.sendUserInfo && item.type == 10">{{item.title}}</span>
						  </div>
						  <el-dropdown-menu slot="dropdown">
						    <!-- 通过 :command 传递参数（对象形式） -->
						    <el-dropdown-item 
						      icon="el-icon-edit" 
						      :command="{data: item, type: 3}"
						    >
						      禁止评论
						    </el-dropdown-item>
						    <el-dropdown-item 
						      icon="el-icon-edit" 
						      :command="{data: item, type: 1}"
						    >
						      禁止购买
						    </el-dropdown-item>
						    <el-dropdown-item 
						      icon="el-icon-edit" 
						      :command="{data: item, type: 2}"
						    >
						      禁止访问
						    </el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="修改库存" :visible.sync="openK" width="600px" append-to-body>
		  <el-table :data="formK.specificationList" border>
		    <el-table-column label="规格名称" align="center" prop="specificationName"/>
			<el-table-column label="价格(元)" align="center" prop="price"/>
		    <el-table-column label="库存" align="center" prop="inventory">
				<template slot-scope="scope">
					<el-input v-model="scope.row.inventory" placeholder="请输入库存"/>
				</template>
			</el-table-column>
		  </el-table>
		  <div slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitFormK">确 定</el-button>
		    <el-button @click="openK = false">取 消</el-button>
		  </div>
		</el-dialog>
		
		<el-dialog title="修改定时上架时间" :visible.sync="open2" width="500px" append-to-body>
		  <el-form ref="form" :model="form2" :rules="rules" label-width="100px">
		    <el-form-item label="定时上架时间" prop="time">
		      <el-time-picker v-model="form2.time" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="定时上架时间" value-format="HH:mm:ss"></el-time-picker>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitForm2">确 定</el-button>
		    <el-button @click="open2 = false">取 消</el-button>
		  </div>
		</el-dialog>
		
		<el-dialog title="修改定时下架时间" :visible.sync="open3" width="500px" append-to-body>
		  <el-form ref="form" :model="form3" :rules="rules" label-width="100px">
		    <el-form-item label="定时下架时间" prop="time">
		      <el-time-picker v-model="form3.time" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="定时下架时间" value-format="HH:mm:ss"></el-time-picker>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitForm3">确 定</el-button>
		    <el-button @click="open3 = false">取 消</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import { getRoomInfo,createTencentCloudImUserSig,getLiveOnlineUserList,getLiveInStatistics,
	getLiveRoomAddGoodsList,getEndStatistics,updateGoodsExplanationStatus,updateGoodsStatus,
	delGoods,updateGoodsSort,updGoods,getGoodsDetails,getForbidUserList,addForbid,relieveForbid,
	updateGoodsTaskListedTime,updateGoodsTaskShelvesTime} from "@/api/zhibo";
	import TRTC from 'trtc-sdk-v5';
	import Cookies from 'js-cookie';
	export default {
	  data() {
	    return {
		  loading:false,
	      data:'',
		  userList:[],
		  trtc: null,
		  remoteStream: null,
		  roomId:this.$route.query.roomId,
		  token:this.$store.state.token,
		  userSign:null,
		  appId:1600106184,
		  userId:null,
		  msgList: [{
		  	title: '平台严禁未成年人充值打赏，严禁以陪玩等方式诱导打赏私下交易，严禁涉黃涉政、谩骂等内容，请注意财产安全，谨防网络诈骗，理性消费。'
		  }],
		  liveInData:'',
		  timer:null,
		  goodsList:[],
		  openK:false,
		  formK:{},
		  navList:[{
			  name:'在线'
		  },{
			  name:'已封禁'
		  }],
		  navListIndex:0,
		  //修改定时上下架时间
		  open2:false,
		  form2:{
		  	dbRecordId:'',
		  	time:'',
		  	roomId:this.$route.query.roomId,
		  },
		  open3:false,
		  form3:{
		  	dbRecordId:'',
		  	time:'',
		  	roomId:this.$route.query.roomId,
		  },
		  rules:{}
	    };
	  },
	  created() {
	    //直播间详情
		this.getRoomInfo()
		//直播间商品
		this.getLiveRoomAddGoodsList()
		this.getMessage()
	  },
	  methods: {
		getMessage() {
		  this.$ws.onMessage = res => {
		    const data = JSON.parse(res);
			if(data.data && data.data.pushType == 1){
				console.log('更新用户')
				this.getLiveOnlineUserList()
			}
			if(data.data && data.data.pushType == 3){
				console.log(data)
				let msg = data.data.details
				msg.title = data.data.title
				console.log(msg)
				this.msgList.push(msg)
				this.$nextTick(() => this.scrollDanmuToBottom());
			}
			if(data.data && data.data.pushType == 2){
				console.log('更新用户3')
				this.getLiveOnlineUserList()
			}
			if(data.data && data.data.pushType == 4){
				this.getRoomInfo()
			}
			if(data.data && data.data.pushType == 5){
				this.getRoomInfo()
				setTimeout(v=>{
					this.destroyTRTC()
				},500)
			}
			if(data.data && data.data.pushType == 7){
				console.log(data)
				if(data.data.details.sendUserInfo){
					let msg = data.data.details
					msg.title = data.data.title
					this.msgList.push(msg)
					this.$nextTick(() => this.scrollDanmuToBottom());
				}
			}
			if(data.data && data.data.pushType == 9){
				this.getLiveRoomAddGoodsList()
			}
			if(data.data && data.data.pushType == 10){
				console.log(data)
				this.data.giveCount = data.data.details.giveCount
				if(data.data.details.sendUserInfo){
					let msg = data.data.details
					msg.title = data.data.title
					msg.type = 10
					this.msgList.push(msg)
				}
				this.$nextTick(() => this.scrollDanmuToBottom());
			}
			if(data.code == 401){
				this.destroyTRTC()
			}
		    
		  };
		},
		// 新增：弹幕滚动到底部的方法
		scrollDanmuToBottom() {
		    // 获取弹幕容器DOM（通过ref）
		    const danmuContainer = this.$refs.danmuContainer;
		    if (danmuContainer) { // 防止DOM未加载时报错
		      // 核心：设置滚动Top = 滚动内容总高度（瞬间滚到底部）
		      danmuContainer.scrollTop = danmuContainer.scrollHeight;
		    }
		},
	    /** 直播间详情 */
	    getRoomInfo() {
	      this.loading = true;
	      getRoomInfo({roomId:this.roomId}).then(response => {
	        this.loading = false
			this.data = response.data
			if(this.data.roomStatus == 1){
				//直播间用户列表
				this.getLiveOnlineUserList()
				//直播中的统计
				this.getLiveInStatistics()
				this.timer = setInterval(v=>{
					this.getLiveInStatistics()
				},20000)
				if(!this.trtc){
					//创建签名
					this.createTencentCloudImUserSig()
				}
				this.$ws.connect(this.roomId,this.token);
			}else{
				this.getEndStatistics()
			}
			
	      });
	    },
		//选择在线还是已封禁
		handleNav(index){
			this.navListIndex = index
			if(index == 0){
				this.getLiveOnlineUserList()
			}else{
				this.getForbidUserList()
			}
		},
		//直播间在线用户
		getLiveOnlineUserList(){
			getLiveOnlineUserList({roomId:this.roomId,page:1,size:5000}).then(response => {
			   this.userList = response.rows
			});
		},
		//直播间封禁用户
		getForbidUserList(){
			getForbidUserList({roomId:this.roomId,page:1,size:5000,type:2}).then(response => {
			   this.userList = response.rows
			});
		},
		//直播间商品
		getLiveRoomAddGoodsList(){
			getLiveRoomAddGoodsList({roomId:this.roomId,page:1,size:1000}).then(response => {
			   this.goodsList = response.rows
			});
		},
		//直播中的统计
		getLiveInStatistics(){
			getLiveInStatistics({roomId:this.roomId}).then(response => {
			  this.liveInData = response.data
			});
		},
		//直播结束统计
		getEndStatistics(){
			getEndStatistics({roomId:this.roomId}).then(response => {
			  this.liveInData = response.data
			});
		},
		//修改库存
		handleUpdateKc(row){
			getGoodsDetails({goodsId:row.goodsId}).then(response => {
			  this.formK = response.data
			  this.openK = true
			});
		},
		//禁止相关
		addForbid(id,type){
			var that = this
			that.$confirm(type===1?'确定禁止该用户购买商品吗？':type===2?'确定禁止该用户访问直播间吗？':'确定禁止该用户发布评论吗？','提示').then(function() {
			  addForbid({
				  toUserId:id,
				  type:type,
				  roomId:that.roomId,
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				that.getLiveOnlineUserList();
			  });
			})
		},
		//点击弹框
		handleCommand(data){
			console.log(data,data.data.sendUserInfo,123)
			this.addForbid(data.data.sendUserInfo.userId,data.type)
		},
		//解除封禁(禁止相关)
		relieveForbid(id,type){
			var that = this
			that.$confirm(type===1?'确定允许该用户购买商品吗？':type===2?'确定允许该用户访问直播间吗？':'确定允许该用户发布评论吗？','提示').then(function() {
			  relieveForbid({
				  toUserId:id,
				  type:type,
				  roomId:that.roomId,
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				if(type == 2){
					that.getForbidUserList();
				}else{
					that.getLiveOnlineUserList();
				}
			  });
			})
		},
		submitFormK(){
			let that = this;
			this.$confirm('确定修改商品库存吗？','提示').then(function() {
			  updGoods(that.formK).then(response => {
			    that.$message({ message: response.msg, type: 'success'});
				that.openK = false
			    that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//讲解取消讲解
		updateGoodsExplanationStatus(dbRecordId,status){
			var that = this
			that.$confirm(status===1?'确定讲解该商品吗？':'确定取消讲解该商品吗？','提示').then(function() {
			  updateGoodsExplanationStatus({
				  dbRecordId:dbRecordId,
				  status:status,
				  roomId:that.roomId,
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//上架下架商品
		updateGoodsStatus(dbRecordId,goodsStatus){
			var that = this
			that.$confirm(goodsStatus===1?'确定上架该商品吗？':goodsStatus===2?'确定下架该商品吗？':'确定设置该商品已售罄吗？','提示').then(function() {
			  updateGoodsStatus({
				  dbRecordId:dbRecordId,
				  goodsStatus:goodsStatus,
				  roomId:that.roomId,
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				that.getLiveRoomAddGoodsList();
			  });
			})
		},
		/** 删除按钮操作 */
		handleDelete(row) {
		  var that = this
		  that.$confirm('确定删除该商品吗？','提示').then(function() {
			  delGoods({
				roomId:that.roomId,
				dbRecordId:row.dbRecordId
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//上移 下移
		updateGoodsSort(dbRecordId,type){
			var that = this
			that.$confirm(type===1?'确定下移该商品吗？':'确定上移该商品吗？','提示').then(function() {
			  updateGoodsSort({
				  dbRecordId:dbRecordId,
				  type:type,
				  roomId:that.roomId,
			  }).then(response => {
				that.$message({ message: response.msg,type: 'success'});
				that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//修改定时上架
		handleUpdateDssj(row){
			this.form2.dbRecordId = row.dbRecordId
			this.form2.time = row.taskListedTime
			this.open2 = true
		},
		submitForm2(){
			let that = this;
			this.$confirm('确定修改定时上架时间吗？','提示').then(function() {
			  updateGoodsTaskListedTime(that.form2).then(response => {
			    that.$message({ message: response.msg, type: 'success'});
				that.open2 = false
			    that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//修改定时下架
		handleUpdateDsxj(row){
			this.form3.dbRecordId = row.dbRecordId
			this.form3.time = row.taskShelvesTime
			this.open3 = true
		},
		submitForm3(){
			let that = this;
			this.$confirm('确定修改定时下架时间吗？','提示').then(function() {
			  updateGoodsTaskShelvesTime(that.form3).then(response => {
			    that.$message({ message: response.msg, type: 'success'});
				that.open3 = false
			    that.getLiveRoomAddGoodsList();
			  });
			})
		},
		//创建签名
		createTencentCloudImUserSig(){
			createTencentCloudImUserSig({roomId:this.roomId}).then(response => {
			  this.userSign = response.data.userSig
			  this.userId = response.data.token
			  this.initTRTC()
			});
		},
		async initTRTC() {
		  this.trtc = TRTC.create();
		  // 修改远程视频流事件处理
		  this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, async ({ userId, streamType }) => {
		    console.log('远端视频流可用1', userId, streamType);
		    try {
		      // 添加500ms延迟确保视频流完全准备好
		      await new Promise(resolve => setTimeout(resolve, 500));
		      await this.trtc.startRemoteVideo({ 
		        userId, 
		        streamType, 
		        view: document.getElementById('remote-video'),
		        // 添加渲染配置
		        renderParams: {
		          mirror: false,
		          objectFit: 'cover',
		          smooth: true // 启用平滑渲染
		        }
		      });
			  this.isVideoSubscribed = true;
		    } catch (error) {
		      console.error('启动远程视频失败:', error);
		    } finally {
		      
		    }
		  });
		  
		  this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, ({ userId, streamType }) => {
		    console.log('远端视频流不可用', userId, streamType);
		    
		  });
		  // 监听远程视频流类型变化（摄像头切换）
		  this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_STREAM_TYPE_CHANGED, ({ userId, oldStreamType, newStreamType }) => {
		    console.log(`用户 ${userId} 视频流类型从 ${oldStreamType} 变为 ${newStreamType}`);
		  });
		  this.trtc.on(TRTC.EVENT.KICKED_OUT, event => {
		    
		  });
		  
		  try {
		    await this.trtc.enterRoom({ 
		      strRoomId: this.roomId, 
		      sdkAppId: this.appId, 
		      userId: this.userId, 
		      userSig: this.userSign,
			  enableAutoPlayDialog: false
		    });
		    console.log('加入房间成功');
		  } catch (error) {
		    console.error('加入房间失败' + error);
		  }
		},
		/** 销毁TRTC实例，释放资源 */
		destroyTRTC() {
		  if (this.trtc) {
		    this.trtc.exitRoom();
		    this.trtc.destroy();
		    this.trtc = null;
		  }
		  if(this.timer){
		  	clearInterval(this.timer)
		  	this.timer = null
		  }
		  this.$ws.close();
		},
		
	  },
	  // 在页面销毁时调用（避免内存泄漏）
	  beforeUnmount() {
	    this.destroyTRTC();
	  },
	};
</script>

<style scoped lang="scss">
	.box{
		min-height: 100vh;
		background-image: url('https://ahhzy.oss-cn-hangzhou.aliyuncs.com/webStorage/web_1758165544092572.png');
		background-size: cover;
		background-position: center;
		min-width: 1024px;
	}
	.box-top{
		
	}
	.box-content{
		display: flex;
		flex-direction: row;
	}
	.box-content-item{
		padding: 30px 10px;
		width: 240px;
	}
	.box-content-video{
		padding: 30px 10px;
		width: 240px;
		// 新增：使用flex垂直布局
	    display: flex;
	    flex-direction: column;
	    gap: 20px; // 视频和弹幕之间的间距
	}
	.box-content-item-user{
		background: #2A3761;
		border-radius: 20px 20px 20px 20px;
		/* 关键高度计算：视口高度 - 60px */
		height: calc(100vh - 60px); 
		/* 可选：若内容溢出，添加滚动条（避免内容超出容器） */
		overflow-y: auto; 
		padding:0px 10px;
		position: relative;
	}
	::-webkit-scrollbar {
	    width: 1px; // 滚动条宽度
	    height: 8px; // 横向滚动条高度
	}
	  
	// 滚动条轨道
	::-webkit-scrollbar-track {
	    //background: rgba(255, 255, 255, 0.00); // 半透明黑色轨道
		background: #2A3761;
	    border-radius: 1px; // 轨道圆角
	}
	  
	// 滚动条滑块
	::-webkit-scrollbar-thumb {
	    //background: rgba(255, 255, 255, 0.2); // 半透明白色滑块
		background: #2A3761;
	    border-radius: 1px; // 滑块圆角
	    transition: background 0.3s ease; // 过渡动画
	}
	  
	// 滚动条滑块悬停状态
	::-webkit-scrollbar-thumb:hover {
	    //background: rgba(255, 255, 255, 0.3); // 悬停时加深颜色
		background: #2A3761;
	}
	  
	// 滚动条角落（垂直和水平滚动条交汇处）
	::-webkit-scrollbar-corner {
	    background: transparent; // 角落透明
	}
	.nav{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 10px 30px;
		background: #2A3761;
		position: absolute;
		left: 0;
		top: 0;
		width: 180px;
	}
	.nav-item{
		width: 70px;
		padding: 4px 8px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #285FFF;
		font-family: MiSans, MiSans;
		font-weight: bold;
		font-size: 14px;
		color: #285FFF;
	}
	.nav-item1{
		width: 70px;
		padding: 4px 8px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #285FFF;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.user-list{
		padding-top: 40px;
	}
	.box-content-item-user-item{
		display: flex;
		flex-direction: column;
		padding: 16px 0px;
		border-bottom: 0.5px solid #1B283B;
	}
	.box-content-item-user-item-left{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.box-content-item-user-item-left-img{
		width: 38px;
		height: 38px;
		border-radius: 50%;
		object-fit: cover;
	}
	.box-content-item-user-item-left-content{
		display: flex;
		flex-direction: column;
		padding-left: 10px;
	}
	.box-content-item-user-item-left-content-name{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.box-content-item-user-item-left-content-name img{
		width: 14px;
		height: 14px;
		margin-right: 6px;
	}
	.box-content-item-user-item-left-content-name span{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
	}
	.box-content-item-user-item-left-content-span{
		padding-top: 4px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
	}
	.box-content-item-user-item-box{
		display: flex;
		flex-direction: row;
		padding-top: 12px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 5rpx;
		color: #285FFF;
		line-height: 6px;
	}
	.box-content-item-user-item-box-btn{
		padding: 2px 6px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #285FFF;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #285FFF;
		margin-right: 5px;
	}
	.box-content-item-user-item-box-btn1{
		padding: 2px 6px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF4D4D;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FF4D4D;
		margin-right: 5px;
	}
	.box-content-container{
		flex: 1;
		padding: 30px 0px;
		display: flex;
		flex-direction: column;
	}
	.box-content-container-title{
		text-align: center;
		font-family: MiSans, MiSans;
		font-weight: 600;
		font-size: 32px;
		color: #FFFFFF;
		line-height: 42px;
	}
	.zhiboxiangqing{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding-top: 6px;
	}
	.zhiboxiangqing-img{
		width: 32px;
		height: 32px;
		border-radius: 50%;
	}
	.zhiboxiangqing-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 20px;
		padding-left: 8px;
	}
	.zhibozhong{
		padding: 4px 6px;
		background: rgba(255,77,77,0.9);
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-left: 10px;
		border-radius: 5px;
	}
	.zhibozhong img{
		width: 16px;
		height: 16px;
	}
	.zhibozhong span{
		padding-left: 4px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
	}
	.zhiboxiangqing-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 20px;
		padding-left: 15px;
	}
	.box-data{
		background-image: url('https://ahhzy.oss-cn-hangzhou.aliyuncs.com/webStorage/web_17581655656253479.png');
		background-size: cover;
		background-position: center;
		border-radius: 10px;
		padding: 10px 0px;
		margin-top: 10px;
	}
	.chengjiao{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.chengjiao-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 21px;
	}
	.chengjiao-span1{
		padding-top: 12px;
		font-family: MiSans, MiSans;
		font-weight: 600;
		// 关键：用 vw 单位实现自适应，1vw = 屏幕宽度的1%
		font-size: 3.5vw; 
		color: #FFFFFF;
		line-height: 1.2; // 用倍数替代固定px，确保行高随字体大小同步变化
	}
	.box-data-list{
		display: flex;
		flex-direction: column;
	}
	.box-data-list-box{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.box-data-list-item{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex: 1;
		padding-top: 15px;
	}
	.box-data-list-item-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 21px;
	}
	.box-data-list-item-span1{
		padding-top: 6px;
		font-family: MiSans, MiSans;
		font-weight: 600;
		font-size: 2vw;
		color: #FFFFFF;
		line-height: 1.2; // 用倍数替代固定px，确保行高随字体大小同步变化
	}
	.goods{
		flex: 1 296px;
		margin-top: 10px;
		background: #2A3761;
		border-radius: 20px 20px 20px 20px;
		overflow-y: auto;
	}
	.goods-list{
	    
	}
	.goods-list-item{
		padding: 5px;
		background: #1D2744;
		border-radius: 10px 10px 10px 10px;
		margin: 10px 10px 0px 10px;
	}
	.goods-list-item-top{
		display: flex;
		flex-direction: row;
		position: relative;
	}
	.goods-list-item-top-img{
		width: 82px;
		height: 82px;
		border-radius: 8px 8px 8px 8px;
	}
	.goods-list-item-top-img-img{
		width: 82px;
		height: 82px;
		border-radius: 8px 8px 8px 8px;
		object-fit: cover;
	}
	.paixu{
		width: 29px;
		height: 20px;
		background: rgba(0,0,0,0.5);
		border-radius: 8px 0px 8px 0px;
		position: absolute;
		left: 0;
		top: 0;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;line-height: 20px;
	}
	.jiangjiezhong{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0;
		bottom: 0;
		border-radius: 0px 0px 8px 8px;
		width: 82px;
		height: 26px;
		background: rgba(255,77,77,0.9);
	}
	.jiangjiezhong img{
		width: 12px;
		height: 12px;
	}
	.jiangjiezhong span{
		padding-left: 4px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #FFFFFF;
	}
	.goods-list-item-top-content{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 2px 0px 2px 6px;
		flex: 1;
	}
	.goods-name{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		line-height: 21px;
	}
	.goods-price{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.goods-price-span{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 10px;
		color: #FF4D4D;
		line-height: 16px;
	}
	.goods-price-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #FFFFFF;
		line-height: 16px;
	}
	.goods-dingshi{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.goods-dingshi span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #FFFFFF;
		line-height: 16px;
		padding-right: 10px;
	}
	.goods-list-item-btn{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	.goods-list-item-btn-box{
		display: flex;
		flex-direction: row;
	}
	.goods-list-item-btn-btn{
		width: 42px;
		height: 28px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #285FFF;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #285FFF;
		margin-left: 5px;
	}
	.goods-list-item-btn-btn1{
		width: 42px;
		height: 28px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF4D4D;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FF4D4D;
		margin-left: 5px;
	}
	.goods-list-item-btn-btn2{
		width: 42px;
		height: 28px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #285FFF;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #285FFF;
		margin-left: 5px;
	}
	// 视频容器 - 维持9:16的比例
	// .video-container {
	//     width: 100%; // 宽度自适应父容器
	//     max-width: 240px; // 可选：限制最大宽度
	//     margin: 0 auto; // 居中显示
	    
	//     // 使用padding-top实现9:16比例 (16/9 * 100% = 177.777%)
	//     padding-top: 177.777%;
	//     position: relative;
	// 	border-radius: 8px; // 可选：添加圆角
	// 	background-size: contain;
	// 	//background-position: center center;
	// 	background-repeat: no-repeat;
	// }
	  
	// .remote-video {
	//     // 绝对定位填充整个容器
	//     position: absolute;
	//     top: 0;
	//     left: 0;
	//     right: 0;
	//     bottom: 0;
	    
	//     // 确保视频填充容器并保持比例
	//     width: 100%;
	//     height: 100%;
	//     //background-color: #000; // 添加黑色背景，避免加载时显示白色
	//     border-radius: 8px; // 可选：添加圆角
	// }
	// 视频容器：维持9:16比例，作为图片和视频的父容器
	.video-container {
	  width: 100%; 
	  max-width: 240px; // 保持原容器最大宽度
	  margin: 0 auto; // 水平居中
	  padding-top: 177.777%; // 核心：通过padding维持9:16比例（16/9≈1.777）
	  position: relative; // 父容器相对定位，子元素绝对定位
	  border-radius: 8px; // 保持原圆角
	  overflow: hidden; // 关键：防止图片/视频超出容器圆角（避免露边）
	}
	
	// 底层图片：宽高100%填充容器，不变形
	.video-bg-img {
	  position: absolute; // 绝对定位，贴合父容器
	  top: 0;
	  left: 0;
	  width: 100%; // 宽度100%填充
	  height: 100%; // 高度100%填充
	  z-index: 1; // 图片层级低于视频，确保视频能覆盖在上方
	}
	
	// 远程视频：覆盖在图片上方，同样100%填充
	.remote-video {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: 2; // 视频层级高于图片
	  object-fit: cover; // 视频按比例填满容器（与图片显示规则一致）
	}
	.danmu{
		flex-grow: 1;
		height: 160px; /* 最低高度，防止内容过少时容器过小 */
		background-color: #2A3761;
		border-radius: 8px;
		overflow-y: auto; 
		padding: 10px;
	}
	.danmaku-body-item{
		display: flex;
		flex-direction: row;
		margin-bottom: 6px;
	}
	.danmaku-body-item-box{
		word-wrap: break-word;
		word-break: break-all;
	}
	.guanliyuan{
		padding: 1px 4px;
		background: linear-gradient( 98deg, #5ECFFF 0%, #0059FF 100%);
		border-radius: 4px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
		line-height: 16px;
		margin-right: 8px;
	}
	.danmaku-body-item-box-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #58EEE6;
		line-height: 19px;
	}
	.danmaku-body-item-box-text1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		line-height: 19px;
	}
	.danmaku-body-item-box-text2{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #58EEE6;
		line-height: 19px;
	}
	.danmaku-body-item-box-text3{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFD272;
		line-height: 19px;
	}
	.unread-tip {
		position: absolute;
		bottom: 0;
		left: 0;
		background: #FFFFFF;
		color: #FF0404;
		padding: 4px;
		border-radius: 10px;
		font-size: 10px;
		z-index: 100;
	}
</style>


// WEBPACK FOOTER //
// zhibodaping.vue?964c1a46